import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import styles from './AgencyLeaderboard.module.scss';
import Typography from '@primitives/Typography/Typography';
import ArrowDownIcon from '@navi/web-ui/lib/icons/ArrowDownIcon';
import cx from 'classnames';
import EMICollectionEfficiency from './EMICollectionEfficiency';
import DisplayAmount from './DisplayAmount';
import CashCollectedChart from './CashCollectedChart';
import { fullMonthNames } from '@cp/src/constants/Common.constants';
import { getServerTime } from '@cp/src/utils/DateHelper';
import { levelIcons } from './constants';
import { getAgencyName } from './utils';

const AgencyLeaderboard = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const user = useSelector((state: RootState) => state?.common?.userData);
  const agencyName = user?.agencyName || '';

  const handleOnClick = () => {
    setIsExpanded(!isExpanded);
  };
  const data = useSelector((state: RootState) => state?.agencyDashboard?.agencyRankingData);
  const todaysDate = new Date(getServerTime());
  const currMonth = fullMonthNames[todaysDate?.getMonth() || 0];
  const currYear = todaysDate?.getFullYear();
  const currMonthAndYear = `${currMonth} ${currYear}`;

  if (!data?.rank) return <></>;
  return (
    <>
      <div
        className={cx(styles.leaderboardContainer, {
          [styles.leaderBoardActive]: isExpanded
        })}
      >
        <GridRow
          onClick={handleOnClick}
          className={isExpanded ? styles.activeHeader : styles.header}
        >
          <Typography variant="p5" className="text-[var(--grayscale-2)] text-sm">
            {getAgencyName(agencyName)}
          </Typography>
          <div className="flex">
            <Typography variant="p5" className="text-[var(--grayscale-2)] text-sm mr-2">
              {currMonthAndYear} Cash Collected
            </Typography>
            <Typography variant="p5" className="text-[var(--grayscale-1)] font-semibold text-sm">
              <DisplayAmount amount={data?.currentMonthData?.totalCashCollected || 0} />
            </Typography>
          </div>
          <div>
            <div className="flex items-center">
              <Typography className="text-[var(--grayscale-2)] text-sm mr-2" variant="p5">
                Perf Level
              </Typography>
              {data?.rank ? levelIcons[data?.rank - 1] : <Typography variant="p5">-</Typography>}
              <Typography className="text-sm mr-3 text-[var(--grayscale-2)]" variant="p5">
                / {data?.maxLevel}
              </Typography>
              <ArrowDownIcon
                color="var(--blue-base)"
                className={isExpanded ? styles['rotate-down'] : styles['rotate']}
              />
            </div>
          </div>
        </GridRow>
        {isExpanded ? (
          <div className={styles.content}>
            <EMICollectionEfficiency
              currentEfficiency={data?.performanceLevelThresholds?.currentEfficiency}
              currentTarget={data?.performanceLevelThresholds?.currentTarget}
              targetAchievementPercent={data?.performanceLevelThresholds?.targetAchievementPercent}
              maxEfficiency={data?.performanceLevelThresholds?.maxEfficiency}
              currMonthAndYear={currMonthAndYear}
            />
            <CashCollectedChart
              prevMonthData={data?.prevMonthData}
              currMonthData={data?.currentMonthData}
            />
          </div>
        ) : null}
      </div>

      {isExpanded ? <div onClick={handleOnClick} className={styles.overlay}></div> : null}
    </>
  );
};
export default AgencyLeaderboard;
